import { addDiscountIndicators, bindQuantityButtonClickHandler, initializeQuantityButtons, swapAttributeImagesForEnglish } from '../default-modules/default-utils';
import { getCategoryIcon } from './category-icons';
import { initFilterSlider } from './project-filter-slider';

let hooksBound = false;

export function prodGroupFunctionality() {
  markBrokenImages();
  injectGroupViewIcons();
  addGroupViewReadMore();
}

export function productListFunctionality() {
  if (!document.querySelector('.prodlist')) return;

  initProductListFunctionality();
  bindUpdateHooks();
}

function initProductListFunctionality() {
  createCategoriesGrid();
  addQtyBtns();
  initQuantityControls();
  addDiscountIndicators(document.querySelector('.prodlist'));
  swapAttributeImagesForEnglish(document.querySelector('.prodlist'));
  customizeFilterAndSort();
  customizePager();
  initFilterSlider();
}

function bindUpdateHooks() {
  if (hooksBound) return;
  hooksBound = true;

  const prm = window.Sys?.WebForms?.PageRequestManager?.getInstance?.();
  if (prm) {
    prm.add_pageLoaded((_sender, args) => {
      const updated = args.get_panelsUpdated?.() || [];
      const updatedIds = updated.map((p) => p?.id).filter(Boolean);

      // Kör bara när UpdatePanel1 kör. Det är häri produktlistan ligger
      if (updatedIds.includes('UpdatePanel1') || updatedIds.some((id) => id.includes('UpdatePanel'))) {
        initProductListFunctionality();
      }
    });
  }
}

function addQtyBtns() {
  initializeQuantityButtons('.prodlist .quantity', '.numeric');
}

function initQuantityControls() {
  bindQuantityButtonClickHandler();
}

function customizeFilterAndSort() {
  const filterWrapper = document.getElementById('FilterWrapper');

  if (!filterWrapper) return;

  createSortSelect();
  createMobileFilterLayout();
}

// Vi bygger om sorteringen till en dropdown istället. Enligt skiss
function createSortSelect() {
  const sortOptions = document.getElementById('SortOptions');

  if (!sortOptions || sortOptions.classList.contains('custom-sort-processed')) return;

  sortOptions.classList.add('custom-sort-processed');

  const sortButtons = sortOptions.querySelectorAll('a.sort');

  if (sortButtons.length === 0) return;

  const activeBtn = sortOptions.querySelector('a.sort.fw-button-active, a.sort.active, a.sort[class*="active"]');

  const select = document.createElement('select');

  select.className = 'wl-sort-select wl-script-added';
  select.id = 'WlSortSelect';

  const defaultOption = document.createElement('option');

  defaultOption.value = '';
  defaultOption.textContent = 'Välj sortering';

  select.appendChild(defaultOption);

  sortButtons.forEach((btn) => {
    const option = document.createElement('option');
    option.value = btn.id;
    option.textContent = btn.textContent.trim();

    if (activeBtn && btn.id === activeBtn.id) {
      option.selected = true;
    }

    select.appendChild(option);
  });

  sortOptions.parentNode.insertBefore(select, sortOptions);

  sortOptions.style.display = 'none';

  select.addEventListener('change', function (e) {
    if (e.target.value) {
      const selectedBtn = document.getElementById(e.target.value);
      if (selectedBtn) {
        selectedBtn.click();
      }
    }
  });
}

// Skapat enligt skiss för att visa filter vid knappklick i mobil
function createMobileFilterLayout() {
  const filterToggle = document.getElementById('FilterToggle');
  const filterContentWrapper = document.getElementById('FilterContentWrapper');

  if (!filterToggle || !filterContentWrapper) return;

  filterToggle.addEventListener(
    'click',
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      filterContentWrapper.classList.toggle('wl-filter-open');

      const isOpen = filterContentWrapper.classList.contains('wl-filter-open');

      this.setAttribute('aria-expanded', isOpen.toString());

      this.classList.toggle('active', isOpen);
    },
    true
  );
}

function addGroupViewReadMore() {
  const groupView = document.getElementById('MainContent_GroupView');

  if (!groupView) return;

  const textElements = groupView.querySelectorAll('.groupview-text');

  if (!textElements.length) return;

  textElements.forEach((textEl) => {
    if (textEl.classList.contains('wl-read-more-processed')) return;
    textEl.classList.add('wl-read-more-processed', 'groupview-text--clamped');

    if (textEl.scrollHeight <= textEl.clientHeight) {
      textEl.classList.remove('groupview-text--clamped');
      return;
    }

    const btn = document.createElement('button');

    btn.className = 'wl-read-more-btn';
    btn.type = 'button';
    btn.textContent = 'LÄS MER';

    textEl.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', () => {
      textEl.classList.remove('groupview-text--clamped');
      btn.remove();
    });
  });
}

function injectGroupViewIcons() {
  const groupView = document.getElementById('MainContent_GroupView');

  if (!groupView) return;

  const noImageItems = groupView.querySelectorAll('.item.images-no');

  if (!noImageItems.length) return;

  noImageItems.forEach((item) => {
    const link = item.querySelector('.group-link');
    const titleSpan = item.querySelector('.group-title');

    if (!link || !titleSpan) return;

    // Check if icon already injected
    if (link.querySelector('.wl-category-icon')) return;

    const categoryName = titleSpan.textContent.trim();
    const iconPath = getCategoryIcon(categoryName);

    if (!iconPath) return;

    const icon = document.createElement('img');

    icon.src = iconPath;
    icon.alt = '';
    icon.className = 'wl-category-icon';

    link.insertBefore(icon, titleSpan);
    item.classList.add('wl-has-category-icon');
  });

  groupView.classList.add('wl-category-icons-injected');
}

function createCategoriesGrid() {
  if (!document.querySelector('.page-Start')) return;

  const tree = document.getElementById('Tree');

  if (!tree) return;

  const navTree = tree.querySelector('.nav-tree');

  if (!navTree) return;

  if (document.querySelector('.wl-categories-grid__wrapper')) return;

  const listElements = navTree.querySelectorAll(':scope > ul > li');

  if (listElements.length === 0) return;

  let heading = 'Våra produktkategorier';
  if (document.querySelector('html[lang="en"]')) {
    heading = 'Our product categories';
  }

  let html = `<h3 class="">${heading}</h3><div class="wl-categories__grid">`;

  listElements.forEach((li) => {
    const link = li.querySelector('a');
    if (!link) return;

    const categoryName = link.textContent.trim();
    const iconPath = getCategoryIcon(categoryName);

    if (!iconPath) return;

    html += `
      <a href="${link.href}" class="wl-category__item">
        <span>
          <img class="wl-category__icon" src="${iconPath}" alt="" />
        </span>
        <span class="wl-category__name">
          ${categoryName}
        </span>
      </a>
    `;
  });

  html += '</div>';

  const container = document.createElement('div');
  container.className = 'wl-categories-grid__wrapper';
  container.innerHTML = html;

  const MainContainer = document.querySelector('#MainContainer');

  MainContainer?.before(container);
}

// Omstrukturerar pagineringen enligt skiss
// Eftersom Pyramid är Pyramid så visar de bara "Sida yadda av yaddayadda" i pagineringen. Men vi vill kunna hoppa mellan olika
function customizePager() {
  const pagerBottom = document.getElementById('PagerBottom');

  if (!pagerBottom) return;

  const pagerInner = pagerBottom.querySelector('.pager_inner');

  if (!pagerInner) return;

  if (pagerBottom.querySelector('.wl-pager-rebuilt')) return;

  const pagerText = pagerInner.querySelector('.pagerText');
  const nextButton = pagerInner.querySelector('#NextButton');
  const lastButton = pagerInner.querySelector('#LastButton');
  const previousButton = pagerInner.querySelector('#PreviousButton');
  const firstButton = pagerInner.querySelector('#FirstButton');

  if (!pagerText) return;

  const textContent = pagerText.textContent.trim();
  // Language-agnostic: matches "word(s) NUMBER word(s) NUMBER" pattern
  // Works for "Sida 1 av 5", "Page 1 of 5", "Seite 1 von 5", etc.
  const match = textContent.match(/\D+(\d+)\D+(\d+)/);

  if (!match) return;

  const currentPage = parseInt(match[1]);
  const totalPages = parseInt(match[2]);

  // Extract localized labels from the original pager elements
  const pageWord = textContent.match(/^\s*(\S+)/)?.[1] || 'Page'; // "Sida", "Page", etc.
  const nextLabel = nextButton?.getAttribute('title') || 'Next';
  const prevLabel = previousButton?.getAttribute('title') || 'Previous';
  const nextPageLabel = `${nextLabel} ${pageWord}`.toUpperCase();
  const nextPageTitle = `${nextLabel} ${pageWord.toLowerCase()}`;

  const rebuiltPager = document.createElement('div');
  rebuiltPager.className = 'wl-pager-rebuilt';

  let nextPageButton = '';

  if (currentPage < totalPages && nextButton) {
    nextPageButton = `
      <a href="${nextButton.href}" class="wl-pager-next-button" title="${nextPageTitle}">
        ${nextPageLabel}
      </a>
    `;
  } else if (currentPage < totalPages && lastButton) {
    nextPageButton = `
      <a href="${lastButton.href}" class="wl-pager-next-button" title="${nextPageTitle}">
        ${nextPageLabel}
      </a>
    `;
  }

  let pageNumbersHtml = '<div class="wl-pager-numbers">';

  if (currentPage > 1 && previousButton) {
    pageNumbersHtml += `<a href="${previousButton.href}" class="wl-pager-arrow" title="${prevLabel}"><i class="fw-icon-angle-left"></i></a>`;
  } else {
    pageNumbersHtml += `<span class="wl-pager-arrow wl-pager-disabled"><i class="fw-icon-angle-left"></i></span>`;
  }

  for (let i = 1; i <= totalPages; i++) {
    const activeClass = i === currentPage ? ' wl-pager-active' : '';

    let pageUrl = '';
    if (i === 1 && firstButton) {
      pageUrl = firstButton.href;
    } else if (i === totalPages && lastButton) {
      pageUrl = lastButton.href;
    } else if (i === currentPage + 1 && nextButton) {
      pageUrl = nextButton.href;
    } else if (i === currentPage - 1 && previousButton) {
      pageUrl = previousButton.href;
    } else {
      const baseUrl = window.location.href.split('?')[0];
      pageUrl = i === 1 ? baseUrl : `${baseUrl}?page=${i}`;
    }

    if (i === currentPage) {
      pageNumbersHtml += `<span class="wl-pager-number${activeClass}">${i}</span>`;
    } else {
      pageNumbersHtml += `<a href="${pageUrl}" class="wl-pager-number${activeClass}">${i}</a>`;
    }
  }

  if (currentPage < totalPages && nextButton) {
    pageNumbersHtml += `<a href="${nextButton.href}" class="wl-pager-arrow" title="${nextLabel}"><i class="fw-icon-angle-right"></i></a>`;
  } else {
    pageNumbersHtml += `<span class="wl-pager-arrow wl-pager-disabled"><i class="fw-icon-angle-right"></i></span>`;
  }

  pageNumbersHtml += '</div>';

  rebuiltPager.innerHTML = nextPageButton + pageNumbersHtml;

  pagerBottom.appendChild(rebuiltPager);
}

function markBrokenImages() {
  document.querySelectorAll('img.ArtImg').forEach((img) => {
    const markIfBroken = () => {
      if (!img.complete || img.naturalWidth === 0) {
        img.classList.add('is-broken');
        img.closest('.image-inner')?.classList.add('wl-has-broken-image');
      }
    };

    // Om bilden redan hunnit försöka laddas
    markIfBroken();

    // Om den failar senare
    img.addEventListener('error', markIfBroken);
  });
}
